import ConciliacaoAuttarConsultaScreen from "./ConciliacaoAuttarConsultaScreen";
import { EnumTrabalhoTipo } from "@/Models/Sistema/Trabalho/TrabalhoTipo";

export default function ConciliacaoGetNetExtratoEletronicoScreen() {
    return <ConciliacaoAuttarConsultaScreen codTrabalhoTipo={EnumTrabalhoTipo.ConciliacaoGetNetExtratoEletronico} />;
}
